import { StatusLogRequest } from "../../api/models/StatusLogRequest";
import { getSessionCookie } from "../../components/cookies";
import { store } from "../../store";
import { api } from "./make_api";

export enum ResourceType {
    DRIVER_DASHBOARD = "driver_dashboard",
    DRIVERS_OVERVIEW_SIMPLE = "drivers_overview_simple",
    DRIVERS_OVERVIEW_DETAIL = "drivers_overview_detail",
    BREAKS_REPORT = "breaks_report",
    GO_REPORT = "go_report",
    GO_MAP = "go_map",
    NAVI_REPORT = "navi_report",
    NAVI_MAP = "navi_map",
    SHIFTS_MONITORING = "shifts_monitoring",
    NEIGHBORS = "neighbors",
    TRIPS_MAP = "trips_map",
    DRIVER_USAGE_TRIP = "driver_usage_trip",
    PAYMENTS_SUMMARY = "payments_summary",
    PAYMENTS_BY_DRIVER = "payments_by_driver",
    CAPACITY_SELECT = "capacity_select",
    CAPACITY_SET = "capacity_set",
    DRIVER_LIST_MENU = "driver_list_menu",
    RELEASE_NOTE = "release_note",
    WEEKLY_REPORT = "weekly_report",
    WEEKLY_DETAIL = "weekly_detail",
    MANUAL = "manual",
}

export enum StatusType {
    GET_RESOURCE = "get_resource",
    FE_ACTION = "fe_action",
    LOGOUT = "logout",
}

export enum ActionType {
    TRIPS_MAP_USAGE = "trips_map_usage",
    TRIPS_MAP_MONITORING = "trips_map_monitoring",
    NEIGHBORS = "neighbors",
    SET_CAPACITY = "set_capacity",
    SELECT_CAPACITY = "select_capacity",
    PAYMENT_BY_DRIVER = "payments_by_driver",
    PAYMENT_SUMMARY = "payments_summary",
    DRIVER_USAGE_TRIP = "driver_usage_trip",
    SELECT_BREAKS_REPORTS = "select_breaks_reports",
    SELECT_SHIFTS_REPORTS = "select_shift_reports",
    SELECT_TRIPS_REPORTS = "select_trips_reports",
    SELECT_DRIVER_LIST = "select_driver_list",
    GET_RELEASE_NOTES = "get_release_notes",
    GET_WEEKLY_REPORTS = "get_weekly_reports",
    GET_WEEKLY_DETAIL = "get_weekly_detail",
    SET_DRIVER_PERFORMANCE_FEEDBACK = "set_driver_performance_feedback",
    GET_MANUALS = "get_manuals",
}

const getDetailOptions = (actionType?: ActionType | null) => {
    const state = store.getState();
    const start_date = state.shifts.startDate;
    const end_date = state.shifts.endDate;
    const driver_ids = state.shifts.driverIds;
    const office_ids = state.common.officeIds;
    const date = state.common.navigation.date;
    const driverId = state.common.navigation.driverID;

    if (!actionType) {
        return {
            date,
            driverId,
        };
    }

    return {
        start_date,
        end_date,
        driver_ids,
        office_ids,
        action_type: actionType.toString(),
    };
};

export const sendLog = async (
    resource: ResourceType,
    statusType: StatusType,
    actionType?: ActionType | null,
    detailOptions?: any | null
): Promise<void> => {
    const state = store.getState();
    const client = api.getCommonAPI();
    const session = getSessionCookie();
    const user = session.consoleUserId;
    const sessionKey = session.sessionKey;

    const _office = state.common.selectedOfficeId;
    const office = _office ? _office.toString() : "";

    const details = detailOptions
        ? detailOptions
        : getDetailOptions(actionType);

    const request = {
        office,
        user,
        resource,
        details,
        statusType,
        sessionKey,
    } as StatusLogRequest;
    console.debug("Log request:", request);

    const rq = await client.sendStatusLog({ statusLogRequest: request });
    console.debug("Sent log with response:", rq);
};
